import React from 'react';
import { Button } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

function LoginButton({ onClick }) {
  return (
    <Button
      variant="contained"
      fullWidth
      onClick={onClick}
      sx={{
        mb: 2,
        py: 1.5,
        backgroundColor: '#4285F4',
        color: 'white',
        '&:hover': {
          backgroundColor: '#357ae8',
        },
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: 500,
      }}
      startIcon={<GoogleIcon />}
    >
      Continue with Google
    </Button>
  );
}

export default LoginButton;

